import { TypographyElement } from 'UI'
import Text from './text.json'
import { useTheme } from 'react-jss'

export default (text = '', maxLength = 200, textProps, showMoreTextProps, showMore, setShowMore) => {
  const theme = useTheme()
  return (
    showMore
      ? (
        <>
          <TypographyElement
            component='h1'
            variant='caption1'
            {...textProps}
          >
            {text}
          </TypographyElement>
          {
            text.length > maxLength &&
              <TypographyElement
                component='h1'
                cursor='pointer'
                variant='link'
                color={theme.primary[0]}
                handleClick={() => setShowMore(!showMore)}
                {...showMoreTextProps}
              >
                {Text.showLess}
              </TypographyElement>
          }
        </>
        )
      : (
        <>
          <TypographyElement
            component='h1'
            variant='caption1'
            {...textProps}
          >
            {text && `${text.slice(0, maxLength)}...`}
          </TypographyElement>
          {
            text.length > maxLength &&
              <TypographyElement
                component='h1'
                cursor='pointer'
                variant='link'
                color={theme.primary[0]}
                handleClick={() => setShowMore(!showMore)}
                {...showMoreTextProps}
              >
                {Text.showMore}
              </TypographyElement>
          }
        </>
        )
  )
}
